import Input from '@components/Input/Input';
import {
  IconButton,
  InputAdornment,
  TextFieldProps,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import { IconVisibility, IconVisibilityOff } from './PasswordInput.styles';

const PasswordInput: React.FC<TextFieldProps> = (props) => {
  const theme = useTheme();
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  return (
    <Input
      {...props}
      type={isVisible ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              aria-label='toggle password visibility'
              data-testid='visibility-change-button'
              onClick={() => setIsVisible(!isVisible)}
              onMouseDown={handleMouseDownPassword}
              edge='end'
              style={{
                color: props.error
                  ? theme.palette.error.main
                  : theme.palette.grey.A100,
              }}
            >
              {!isVisible ? (
                <IconVisibility data-testid='visibility-icon' />
              ) : (
                <IconVisibilityOff data-testid='visibility-off-icon' />
              )}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordInput;
